import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const AppHelmet = ({ children, ...passingProps }) => (
  <Helmet {...passingProps}>
    {children}
    <meta name="robots" content="noindex, follow" />
  </Helmet>
)

AppHelmet.propTypes = {
  children: PropTypes.node,
}

export default AppHelmet
